import React from "react";
import { Home } from "lucide-react";
import { cn } from "../../utils/classMerger";

interface HiddenAddressMapPlaceholderProps
    extends React.HTMLAttributes<HTMLDivElement> {
    isMobile?: boolean;
}

// Stands in for the map of a listing whose MLS hides the address: the feed
// sends no coordinates, so there is no location to show. Same look as the
// listing card's no-image state.
const HiddenAddressMapPlaceholder = React.forwardRef<
    HTMLDivElement,
    HiddenAddressMapPlaceholderProps
>(({ isMobile = false, className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn(
            "flex w-full flex-col items-center justify-center gap-3 rounded-lg bg-primary",
            isMobile ? "h-60" : "h-80",
            className
        )}
        {...props}
    >
        <Home className="h-12 w-12 text-white/60 animate-skeleton" />
        <span className="text-xs font-semibold tracking-wide text-secondary">
            Address hidden by MLS
        </span>
    </div>
));
HiddenAddressMapPlaceholder.displayName = "HiddenAddressMapPlaceholder";

export default HiddenAddressMapPlaceholder;
